import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
            }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Why is tailored financial planning vital for single parents?",
      answer: "Customised planning directly addresses the singular challenges and aspirations of single parents, providing stability and security. We're here to simplify this journey."
    },
    {
      question: "Which investment avenues are ideal for single parents?",
      answer: "We suggest a blend of safe and return-oriented investments and financial stability without unnecessary risks."
    },
    {
      question: "How is tax planning modified for single parents?",
      answer: "Single parents have access to distinct tax-efficient methods which enhance overall savings."
    },
    {
      question: "How do you highlight child-focused budgeting?",
      answer: "Our strategies underscore milestones like education, health, and other essentials in financial blueprints for single parents."
    },
    {
      question: "Should single parents opt for specific insurance schemes?",
      answer: "Each single parent's insurance requirements vary. We guide towards complete coverage for both parent and child."
    },
    {
      question: "How can I safeguard my child's financial well-being?",
      answer: "Our definitive, goal-centric plans, backed by expert counsel, aim at protecting your child's future at every step."
    }
  ];

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Frequently Asked Questions About Single Parent Financial Planning
            </h2>
            <p className="text-gray-600 mb-8">
              Get answers to common questions about financial planning for single parents.
              For more detailed guidance, our experts are here to help.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
